export default "__VITE_ASSET__0Autxqa8__"